import { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "./Header";
import { isValidPhone, isValidName } from "../../Services/validation/validationUtiles";
import adminServices from "../../Services/adminService";
import visaService from "../../Services/visaService";
import "../../assets/css/groupForm.css";
import { isObjectNotEmpty, capitalizeFirstLetter } from "../../utils";

const formInputs = [
  { label: "שם מלא", name: "fullName" },
  { label: "טלפון", name: "phone", type: "tel" },
  { label: "כתובת מגורים", name: "address" },
  { label: "שם חברה", name: "companyName" },
  { label: "כתובת מקום עבודה", name: "workAddress" },
  { label: "מקצוע", name: "profession" },
  { label: "תאריך נחיתה", name: "arrivalDate", type: "date" },
  { label: "שדה נחיתה בוייטנאם", name: "arrivalAirport" },
  { label: "שם מלון בוייטנאם", name: "hotelName" }
];

const defaultFormData = {
  fullName: "",
  phone: "",
  address: "",
  companyName: "",
  workAddress: "",
  profession: "",
  arrivalDate: "",
  arrivalAirport: "",
  hotelName: ""
};

function VietnamForm() {
  let { organizationName, destination, dateOfTrip, groupId, groupAgentName } = useParams();
  organizationName = decodeURIComponent(organizationName);
  destination = decodeURIComponent(destination);
  groupAgentName = decodeURIComponent(groupAgentName);

  const [formData, setFormData] = useState(defaultFormData);
  const [formatErrors, setFormatErrors] = useState({});
  const formQuestions = useRef();

  const onChange = ({ target: { name, value } }) => {
    setFormatErrors((prevFormatErrors) => {
      delete prevFormatErrors[name];
      return { ...prevFormatErrors };
    });
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = (data) => {
    const formatErrors = {};

    if (!isValidName(data.fullName)) {
      formatErrors.fullName = "שם מלא לא תקין";
    }

    if (!isValidPhone(data.phone)) {
      formatErrors.phone = "מספר טלפון לא תקין";
    }

    if (!data.address) {
      formatErrors.address = "נא למלא כתובת";
    }

    if (!data.companyName) {
      formatErrors.companyName = "נא למלא שם חברה";
    }

    if (!data.workAddress) {
      formatErrors.workAddress = "נא למלא כתובת מקום עבודה";
    }

    if (!data.profession) {
      formatErrors.profession = "נא למלא מקצוע";
    }

    if (!data.arrivalDate) {
      formatErrors.arrivalDate = "נא למלא תאריך נחיתה";
    }

    if (!data.arrivalAirport) {
      formatErrors.arrivalAirport = "נא למלא שדה נחיתה";
    }

    if (!data.hotelName) {
      formatErrors.hotelName = "נא למלא שם מלון";
    }

    setFormatErrors(formatErrors);
    return formatErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formatErrors = validateForm(formData);
    if (isObjectNotEmpty(formatErrors)) {
      formQuestions.current.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    const form = new FormData();
    for (const field in formData) {
      form.append(field, formData[field]);
    }
    form.append("groupId", groupId);

    const addParticipantRes = await adminServices.addParticipantToGroup(form);
    const newGroupVisaRes = await visaService.createNewGroupVisa({
      visaData: {
        ...formData,
        destination: capitalizeFirstLetter(destination)
      }
    });

    if (addParticipantRes?.success === true && newGroupVisaRes?.success === true) {
      setFormData(defaultFormData);
      Swal.fire("בוצע בהצלחה", "הטופס נשלח בהצלחה", "success");
    }
  };

  return (
    <div>
      <Header groupAgentName={groupAgentName} organizationName={organizationName} dateOfTrip={dateOfTrip} destination={destination} />

      <form className="group-form-form" onSubmit={handleSubmit} ref={formQuestions}>
        <h2 className="group-form-title">הכל כמעט מוכן לבואכם</h2>

        <div className="group-form-inputs-container">
          {formInputs.map(({ label, name, type }) => (
            <label key={name} className="group-form-input-label">
              {label}:
              <input
                className="group-form-input"
                value={formData[name]}
                name={name}
                type={type || "text"}
                placeholder={label}
                onChange={onChange}
              />
              {formatErrors[name] && <p className="text-format-error">* {formatErrors[name]}</p>}
            </label>
          ))}
        </div>

        <button className="submit-button" type="submit" value="Submit">
          שלח
        </button>
      </form>
    </div>
  );
}

export default VietnamForm;
